import { React, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { loadTossPayments } from '@tosspayments/payment-sdk';

import FetchModule from '../../Share/Network/FetchModule';
import useWindowSize from '../../Share/Normal/useWindowSize';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';

import { ReactComponent as BlackExitSvg } from '../../../image/BlackExit.svg';

function SubscribeModal(props) {
  const { name, validity, price, merchantUid, setIsClicked } = props;

  const clientKey = 'live_ck_4vZnjEJeQVxmOL22lRqrPmOoBN0k';

  const history = useHistory();
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const size = useWindowSize();

  const [customerKey, setCustomerKey] = useState('');
  const [windowSize, setWindowSize] = useState(size);

  useEffect(() => {
    const jquery = document.createElement('script');
    jquery.src = "https://code.jquery.com/jquery-1.12.4.min.js";

    const iamport = document.createElement('script');
    iamport.src = "https://cdn.iamport.kr/js/iamport.payment-1.2.0.js";

    document.head.appendChild(jquery);
    document.head.appendChild(iamport);

    return () => {
      document.head.removeChild(jquery);
      document.head.removeChild(iamport);
    }
  }, []);

  useEffect(() => {
    setWindowSize(size);
  }, [size])

  function onClickPayment(className) {
    (
      async () => {
        const fetchModule = new FetchModule();
        const response = await fetchModule.postData('sales/change/merchant/' + merchantUid + "/normal/" + price, 'POST');
        if (response.status === 200) {
          const { IMP } = window;
          IMP.init('imp22047599');

          setIsClicked(true);

          const data = {
            pg: className === 'toss' ? 'tosspay' : 'jtnet',
            pay_method: 'card',
            name: name,
            amount: price,
            // amount: '100',
            merchant_uid: merchantUid
          }

          IMP.request_pay(data, callback);
        }
        else if (response.status === 201) {
          // 데이터 없음
          alert(t('myStoreSetting.subscribeModal.invalidData'));
          return;
        }
        else if (response.status === 202) {
          // 이미 처리된 데이터
          alert(t('myStoreSetting.subscribeModal.alreadyPaid'));
          return;
        }
        else if (response.status === 203) {
          // 현금결제가 같이있는 경우
          alert(t('myStoreSetting.subscribeModal.noCombinedPayment'));
          return;
        }
        else if (response.status === 204) {
          alert(t('myStoreSetting.subscribeModal.regularPaymentLimit'));
          return;
        }
        else if (response.status === 205) {
          alert(t('myStoreSetting.subscribeModal.alreadyInProgress'));
          return;
        }
        else {
          alert(t('myStoreSetting.subscribeModal.invalidData'));
          return;
        }
      }
    )();
  }

  // 정기결제 클릭시 //
  function onClickRegularPayment() {
    (
      async () => {
        const fetchModule = new FetchModule();
        const response = await fetchModule.postData('sales/change/merchant/' + merchantUid + "/regular/" + price, 'POST');
        if (response.status === 200) {
          const { IMP } = window;
          IMP.init('imp22047599');

          setIsClicked(true);

          const requestData = {
            pg: 'jtnet.tpaytest2m',
            pay_method: 'card',
            name: response.data[0].itemName,
            amount: price,
            merchant_uid: response.data[0].merchantUid,
            customer_uid: response.data[0].userId,
          }
          IMP.request_pay(requestData, callback);
        }
        else if (response.status === 201) {
          alert(t('myStoreSetting.subscribeModal.invalidData'));
          return;
        }
        else if (response.status === 202) {
          alert(t('myStoreSetting.subscribeModal.alreadyPaid'));
          return;
        }
        else if (response.status === 203) {
          alert(t('myStoreSetting.subscribeModal.noCombinedPayment'));
          return;
        }
        else if (response.status === 204) {
          alert(t('myStoreSetting.subscribeModal.regularPaymentLimit'));
          return;
        }
        else if (response.status === 205) {
          alert(t('myStoreSetting.subscribeModal.alreadyInProgress'));
          return;
        }
        else {
          alert(t('myStoreSetting.subscribeModal.invalidData'));
          return;
        }
      }
    )();
  }

  function callback(response) {
    const { success, error_msg, imp_uid, merchant_uid, pay_method, paid_amount, status } = response;

    if (success) {
      const requestData = {
        imp_uid: imp_uid,
        merchant_uid: merchant_uid
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postData('sales/effectiveness', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('myStoreSetting.subscribeModal.paymentComplete'));
          }
          else {
            alert(t('myStoreSetting.subscribeModal.paymentFailed'));
          }
        }
      )();
    }

    setIsClicked(false);
  }

  async function onClickRegularPaymentTest() {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('zone_subscribe/customer', 'GET');

        if (responseData.status === 200) {
          const tossPayments = await loadTossPayments(clientKey);

          tossPayments.requestBillingAuth("카드", {
            customerKey: responseData.data[0].customerUid,
            amount: '77000',
            orderId: responseData.data[0].nextMerchantUid,
            successUrl: 'https://link-zone.io/payment/zone/subscribe/success',
            failUrl: 'https://link-zone.io/payment/zone/subscribe/fail',
          })
        }
        else if (responseData.status === 205){
          alert(t('myStoreSetting.subscribeModal.billingInProgress'));
        }
      }
    )();
  }

  // 정기결제 클릭시 페이플 버전 // 
  function onClickRegularPaymentOnPayple() {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('zone_subscribe/customer/payple', 'GET');
        if (responseData.status === 200) {
          const obj = {};

          obj.PCD_PAY_TYPE = 'card'
          obj.PCD_PAY_WORK = 'PAY'
          obj.PCD_CARD_VER = '01';
          obj.PCD_PAYER_AUTHTYPE = 'sms';
          obj.PCD_PAY_GOODS = responseData.data[0].itemName;
          obj.PCD_PAY_TOTAL = 77000;
          obj.PCD_PAY_OID = responseData.data[0].nextMerchantUid;

          obj.callbackFunction = getResult;
          obj.clientKey = '0F44C92BFB07F1BE60C5235A7254316D';
          window.PaypleCpayAuthCheck(obj);
        }
        else if (responseData.status === 201) {
          alert(responseData.error);
        }
      }
    )();
  }


  // 결제 이후 콜백 //
  function getResult(res) {
    if (res.PCD_PAY_RST === 'success' && res.PCD_PAY_CODE === '0000') {
      let requestData = {
        merchantUid: res.PCD_PAY_OID,
        billingKey: res.PCD_PAYER_ID
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postData('zone_subscribe/create/payple', 'POST', requestData);
  
          if (responseData.status === 200) {
            alert(t('myStoreSetting.subscribeModal.subscriptionComplete'));
            history.push("/main");
          }
        }
      )();
    }
    else {
      if (res.PCD_PAY_CODE === undefined) {
        alert(res.PCD_PAY_MSG);
      }
      else {
        alert('[' + res.PCD_PAY_CODE + ']' + ' ' + res.PCD_PAY_MSG);
      }
    }
  }


  return (
    <TotalModalWrapper>
      <ModalView>
        <InfoBox isDark={isDark}>
          <TitleWrapper>
            <SubTitleWrpper>
              <Title>{t('myStoreSetting.subscribeModal.title')}</Title>
              <ExitButton onClick={() => setIsClicked(false)} />
            </SubTitleWrpper>
            <SubTitle>{t('myStoreSetting.subscribeModal.subtitle')}</SubTitle>
          </TitleWrapper>
          <LayerWrapper>
            <LayerTitle>{t('myStoreSetting.subscribeModal.productInfo')}</LayerTitle>
            <ZoneView>
              <ViewLogo src='https://link-zone.org/api/account/logo' />
              <ViewTextWrapper>
                <ViewTextEng>Link Zone</ViewTextEng>
                <ViewTextKor>{t('myStoreSetting.subscribeModal.productDesc')}</ViewTextKor>
                <ViewTextKor>{t('myStoreSetting.subscribeModal.productPeriod')}</ViewTextKor>
              </ViewTextWrapper>
            </ZoneView>
          </LayerWrapper>
          <LayerWrapper>
            <LayerTitle>{t('myStoreSetting.subscribeModal.finalPayment')}</LayerTitle>
            <PriceWrapper>
              <PriceLayerWrapper>
                <PriceText>{t('myStoreSetting.subscribeModal.productAmount')}</PriceText>
                <PriceLine />
                <PriceText>{t('myStoreSetting.subscribeModal.price')}</PriceText>
              </PriceLayerWrapper>
              <PriceLayerWrapper>
                <TotalPriceText color={theme.text}>{t('myStoreSetting.subscribeModal.finalAmount')}</TotalPriceText>
                <PriceLine />
                <TotalPriceText color={theme.primary}>{t('myStoreSetting.subscribeModal.price')}</TotalPriceText>
              </PriceLayerWrapper>
            </PriceWrapper>
                <PaymentButton onClick={onClickRegularPaymentOnPayple}>{t('myStoreSetting.subscribeModal.subscribePayButton')}</PaymentButton>
          </LayerWrapper>
        </InfoBox>
      </ModalView>
    </TotalModalWrapper>
  )
}

export default SubscribeModal;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 160px;
  margin-bottom: 74px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
  // margin-left: 28px;

  // width: 100%;
  width: 322px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const SubTitleWrpper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const SubTitle = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: ${props => props.theme.primary};

  margin: 0 0 0 0;
`;

const ExitButton = styled(BlackExitSvg)`
  width: 16px;
  height: 16px;

  & path {
    fill: ${props => props.theme.text};
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 378px;
  // height: 828px;
  // height: 600px;
  height: 500px; 

  margin-top: 38px;

  border-radius: 30px;
  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  background-color: ${props => props.theme.subBackground};
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 322px;

  // margin-bottom: 24px;

  border-bottom: 1px solid ${props => props.theme.line};
`;

const LayerTitle = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 24px 0 0 0;
`;

const ZoneView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 322px;
  height: 100px;

  gap: 16px;
  margin-top: 24px;
  margin-bottom: 24px;

  border-radius: 15px;
  background-color: ${props => props.theme.primary};
`;

const ViewLogo = styled.img`
  width: 60px;
  height: 60px;
`;

const ViewTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const ViewTextEng = styled.p`
  font-family: Poppins-Bold;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  margin: 0 0 0 0;
`;

const ViewTextKor = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: ${props => props.theme.subBackground};

  margin: 0 0 0 0;
`;

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 8px;
  margin-top: 24px;
`;

const PriceLayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  gap: 8px;
`;

const PriceText = styled.div`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.red ? props.theme.pointRed : props.theme.subText};

  margin: 0 0 0 0;
  white-space: nowrap;
`;

const PriceLine = styled.div`
  flex: 1;
  height: 1px;

  border: 1px dashed ${props => props.theme.line};
`;

const TotalPriceText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  white-space: nowrap;
`;

const PaymentButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 322px;
  height: 40px;

  border-radius: 15px;
  background-color: ${props => props.theme.primary};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  margin-top: 24px;
  margin-bottom: 24px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;